/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as AuthenticatedBemVindoRouteImport } from './routes/_authenticated/bem-vindo'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedDefinirSenhaRouteImport } from './routes/_authenticated/definir-senha'
import { Route as AuthenticatedPerfilRouteImport } from './routes/_authenticated/perfil'
import { Route as AuthenticatedAdminConfiguracoesRouteImport } from './routes/_authenticated/admin/configuracoes'
import { Route as AuthenticatedAdminDiagnosticosRouteImport } from './routes/_authenticated/admin/diagnosticos'
import { Route as AuthenticatedAdminUsuariosRouteImport } from './routes/_authenticated/admin/usuarios'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBemVindoRoute = AuthenticatedBemVindoRouteImport.update({
  id: '/bem-vindo',
  path: '/bem-vindo',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDefinirSenhaRoute =
  AuthenticatedDefinirSenhaRouteImport.update({
    id: '/definir-senha',
    path: '/definir-senha',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPerfilRoute = AuthenticatedPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminConfiguracoesRoute =
  AuthenticatedAdminConfiguracoesRouteImport.update({
    id: '/admin/configuracoes',
    path: '/admin/configuracoes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminDiagnosticosRoute =
  AuthenticatedAdminDiagnosticosRouteImport.update({
    id: '/admin/diagnosticos',
    path: '/admin/diagnosticos',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminUsuariosRoute =
  AuthenticatedAdminUsuariosRouteImport.update({
    id: '/admin/usuarios',
    path: '/admin/usuarios',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/entrar': typeof EntrarRoute
  '/bem-vindo': typeof AuthenticatedBemVindoRoute
  '/chat': typeof AuthenticatedChatRoute
  '/definir-senha': typeof AuthenticatedDefinirSenhaRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/admin/configuracoes': typeof AuthenticatedAdminConfiguracoesRoute
  '/admin/diagnosticos': typeof AuthenticatedAdminDiagnosticosRoute
  '/admin/usuarios': typeof AuthenticatedAdminUsuariosRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/entrar': typeof EntrarRoute
  '/bem-vindo': typeof AuthenticatedBemVindoRoute
  '/chat': typeof AuthenticatedChatRoute
  '/definir-senha': typeof AuthenticatedDefinirSenhaRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/admin/configuracoes': typeof AuthenticatedAdminConfiguracoesRoute
  '/admin/diagnosticos': typeof AuthenticatedAdminDiagnosticosRoute
  '/admin/usuarios': typeof AuthenticatedAdminUsuariosRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/entrar': typeof EntrarRoute
  '/_authenticated/bem-vindo': typeof AuthenticatedBemVindoRoute
  '/_authenticated/chat': typeof AuthenticatedChatRoute
  '/_authenticated/definir-senha': typeof AuthenticatedDefinirSenhaRoute
  '/_authenticated/perfil': typeof AuthenticatedPerfilRoute
  '/_authenticated/admin/configuracoes': typeof AuthenticatedAdminConfiguracoesRoute
  '/_authenticated/admin/diagnosticos': typeof AuthenticatedAdminDiagnosticosRoute
  '/_authenticated/admin/usuarios': typeof AuthenticatedAdminUsuariosRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/entrar'
    | '/bem-vindo'
    | '/chat'
    | '/definir-senha'
    | '/perfil'
    | '/admin/configuracoes'
    | '/admin/diagnosticos'
    | '/admin/usuarios'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/entrar'
    | '/bem-vindo'
    | '/chat'
    | '/definir-senha'
    | '/perfil'
    | '/admin/configuracoes'
    | '/admin/diagnosticos'
    | '/admin/usuarios'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/entrar'
    | '/_authenticated/bem-vindo'
    | '/_authenticated/chat'
    | '/_authenticated/definir-senha'
    | '/_authenticated/perfil'
    | '/_authenticated/admin/configuracoes'
    | '/_authenticated/admin/diagnosticos'
    | '/_authenticated/admin/usuarios'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  EntrarRoute: typeof EntrarRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/bem-vindo': {
      id: '/_authenticated/bem-vindo'
      path: '/bem-vindo'
      fullPath: '/bem-vindo'
      preLoaderRoute: typeof AuthenticatedBemVindoRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chat': {
      id: '/_authenticated/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/definir-senha': {
      id: '/_authenticated/definir-senha'
      path: '/definir-senha'
      fullPath: '/definir-senha'
      preLoaderRoute: typeof AuthenticatedDefinirSenhaRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/perfil': {
      id: '/_authenticated/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthenticatedPerfilRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/configuracoes': {
      id: '/_authenticated/admin/configuracoes'
      path: '/admin/configuracoes'
      fullPath: '/admin/configuracoes'
      preLoaderRoute: typeof AuthenticatedAdminConfiguracoesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/diagnosticos': {
      id: '/_authenticated/admin/diagnosticos'
      path: '/admin/diagnosticos'
      fullPath: '/admin/diagnosticos'
      preLoaderRoute: typeof AuthenticatedAdminDiagnosticosRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/usuarios': {
      id: '/_authenticated/admin/usuarios'
      path: '/admin/usuarios'
      fullPath: '/admin/usuarios'
      preLoaderRoute: typeof AuthenticatedAdminUsuariosRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedBemVindoRoute: typeof AuthenticatedBemVindoRoute
  AuthenticatedChatRoute: typeof AuthenticatedChatRoute
  AuthenticatedDefinirSenhaRoute: typeof AuthenticatedDefinirSenhaRoute
  AuthenticatedPerfilRoute: typeof AuthenticatedPerfilRoute
  AuthenticatedAdminConfiguracoesRoute: typeof AuthenticatedAdminConfiguracoesRoute
  AuthenticatedAdminDiagnosticosRoute: typeof AuthenticatedAdminDiagnosticosRoute
  AuthenticatedAdminUsuariosRoute: typeof AuthenticatedAdminUsuariosRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedBemVindoRoute: AuthenticatedBemVindoRoute,
  AuthenticatedChatRoute: AuthenticatedChatRoute,
  AuthenticatedDefinirSenhaRoute: AuthenticatedDefinirSenhaRoute,
  AuthenticatedPerfilRoute: AuthenticatedPerfilRoute,
  AuthenticatedAdminConfiguracoesRoute: AuthenticatedAdminConfiguracoesRoute,
  AuthenticatedAdminDiagnosticosRoute: AuthenticatedAdminDiagnosticosRoute,
  AuthenticatedAdminUsuariosRoute: AuthenticatedAdminUsuariosRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  EntrarRoute: EntrarRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
